import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.629 23.25H2.25a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v11.379a1.5 1.5 0 0 1-.439 1.06l-8.122 8.122a1.5 1.5 0 0 1-1.06.439Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 6.75h12m-12 4.5H12m2.652 11.402.05-8.402 8.401-.05",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M13.629%2023.25H2.25a1.5%201.5%200%200%201-1.5-1.5V2.25a1.5%201.5%200%200%201%201.5-1.5h19.5a1.5%201.5%200%200%201%201.5%201.5v11.379a1.5%201.5%200%200%201-.439%201.06l-8.122%208.122a1.5%201.5%200%200%201-1.06.439Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M6.75%206.75h12m-12%204.5H12m2.652%2011.402.05-8.402%208.401-.05%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
